import httpApi from '../api/httpApi';
import {
    AddToCompanyProps,
    LogoUploadResp,
    ProfileRequest,
    User,
} from '../../models/User';

const USER_URL = '/api/v1/user';
const ADD_TO_COMPANY = '/api/v1/company/partner';
const USER_LOGO = '/api/v1/user/logo';

const useUser = () => {
    const getUser = (): Promise<User> => {
        return httpApi.get<User>(USER_URL).then((resp) => {
            return resp.getData();
        });
    };

    const deleteUser = () => {
        return httpApi.del<User>(USER_URL).then((resp) => {
            return resp.getData();
        });
    };

    const updateUser = (user: ProfileRequest) => {
        return httpApi.put<User>(USER_URL, user).then((resp) => {
            return resp.getData();
        });
    };

    const addToCompany = (data: AddToCompanyProps) => {
        return httpApi
            .post<any>(ADD_TO_COMPANY, data)
            .then((resp) => {
                return resp.getData();
            })
            .catch((error) => {
                throw error;
            });
    };

    const uploadCompanyLogo = (data: FormData): Promise<LogoUploadResp> => {
        return httpApi
            .post<LogoUploadResp>(USER_LOGO, data)
            .then((resp) => {
                return resp.getData();
            })
            .catch((error) => {
                throw error;
            });
    };

    const deleteCompanyLogo = (): Promise<null> => {
        return httpApi
            .del<null>(USER_LOGO)
            .then((resp) => {
                return resp.getData();
            })
            .catch((error) => {
                throw error;
            });
    };

    return {
        getUser,
        deleteUser,
        updateUser,
        addToCompany,
        uploadCompanyLogo,
        deleteCompanyLogo,
    };
};

export default useUser;
